import { render, staticRenderFns } from "./ProRiskFilter.vue?vue&type=template&id=1c9c5c92&"
import script from "./ProRiskFilter.vue?vue&type=script&lang=ts&"
export * from "./ProRiskFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports